import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import './icon-button.css';

const IconButton = ({
    img, disabled, className, title, onClick, iconClassName, componentRef
}) => (<div
    ref={componentRef}
    className={disabled ? `containerConnect ${className} disabled` : `containerConnect ${className}`}
    // className={classNames(styles.container, className, disabled ? styles.disabled : null)}
    role="button"
    onClick={disabled ? null : onClick}
>
    <img
        className="iconConnectBtn iconClassName"
        draggable={false}
        src={img}
    />
    {title && <div className="title">
        {title}
    </div>}
</div>);

IconButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    img: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.node,
    iconClassName: PropTypes.string,
    componentRef: PropTypes.func
};

export default IconButton;
